import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_payroll,
  add_payroll,
  update_payroll,
  delete_payroll,
  get_payroll_salary
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const getTodayDate = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    today.setMinutes(today.getMinutes() - offset);
    return today.toISOString().split("T")[0];
  };
const initialState = {
  payrolls: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    payment_date:getTodayDate()||"",
    user :"",
    month :"",
    uin_number:"",
    day_in_month:"",
    payable_days:"",
    basic_salary :"",
    net_salary :"",
    gross_salary:"",
    total_deduction:"",
    epf_12:"",
    epf_edli:"",
    esic:"",
    gratuity:"",
    bonus:"",
    ctc:"",
    status:"Pending"
  },
  filterData: {
    date:"",
    month:"",
    user: "",
  },
};

export const fetchusersalary = createAsyncThunk(
    "payroll/fetchusersalary",
    async (
      { id, token, signal },
      { rejectWithValue }
    ) => {
      try {
        const response = await get_payroll_salary(
          id,
          token,
          signal
        );
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
// Async Thunks for API Calls
export const fetchpayroll = createAsyncThunk(
  "payroll/fetchpayroll",
  async (
    { page, page_size, school_id,date,month,user, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_payroll(
        page,
        page_size,
        school_id,
        date,month,user,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createpayroll = createAsyncThunk(
  "payroll/createpayroll",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_payroll(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatepayroll = createAsyncThunk(
  "payroll/updatepayroll",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_payroll(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletepayroll = createAsyncThunk(
  "payroll/deletepayroll",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_payroll({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const payrollSlice = createSlice({
  name: "payrolls",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        date,
        student,
        exam
      } = action.payload;
      state.formData = {
        id,
        date,
        student,
        exam
      };
    },
    resetFormData(state) {
      state.formData = {
        payment_date:getTodayDate()||"",
        user :"",
        month :"",
        uin_number:"",
        day_in_month:"",
        payable_days:"",
        basic_salary :"",
        net_salary :"",
        gross_salary:"",
        total_deduction:"",
        epf_12:"",
        epf_edli:"",
        esic:"",
        gratuity:"",
        bonus:"",
        ctc:"",
        status:"Pending"
      };
    },
    setpayroll(state, action) {
      state.payrolls = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
       // Fetch Classes
       .addCase(fetchusersalary.fulfilled, (state, action) => {
        state.formData.basic_salary = action.payload.data.salary;
      })
      .addCase(fetchusersalary.rejected, (state, action) => {
        state.formData.basic_salary = 0;


      })
      .addCase(fetchpayroll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchpayroll.fulfilled, (state, action) => {
        state.loading = false;
        state.payrolls = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchpayroll.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.payrolls = [];

      })

      // Add Class
      .addCase(createpayroll.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createpayroll.fulfilled, (state, action) => {
        state.addLoading = false;
        state.payrolls = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createpayroll.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatepayroll.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatepayroll.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatepayroll.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletepayroll.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletepayroll.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletepayroll.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setpayroll,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,

} = payrollSlice.actions;
export default payrollSlice.reducer;
